"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encode = void 0;
var encode = function (user) {
    var _a, _b;
    return (__assign(__assign({}, user), { birthdate: 'birthdate' in user ? (_b = (_a = user.birthdate) === null || _a === void 0 ? void 0 : _a.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        })) !== null && _b !== void 0 ? _b : '' : undefined }));
};
exports.encode = encode;
exports.default = exports.encode;
